import { useTranslation } from 'react-i18next';
import { isAadeQrUrl, useDeliveryStatusByQrUrl } from '../../../api/hooks/delivery/useDeliveryStatusByQrUrl';
import { Loading } from '../../../components/atoms/Loading';
import { DeliveryStatusGsisDoc } from './DeliveryStatusGsisDoc';
import { DeliveryStatusSteps } from './DeliveryStatusSteps';

interface Props {
  qrUrl: string | undefined;
}

export const DeliveryStatusByQrUrl = ({ qrUrl }: Props) => {
  const { t } = useTranslation();
  const { data, isLoading } = useDeliveryStatusByQrUrl(qrUrl);

  if (!isAadeQrUrl(qrUrl)) return null;
  if (isLoading) return <Loading global />;
  if (!data) return null;

  if (data.errorCode && !data.data) {
    return (
      <div className="width-100 m-t-16 flex-center-center-column-nowrap">
        <div className="boldText4 text-center text-danger">{t(`API_ERRORS.${data.errorCode}`)}</div>
      </div>
    );
  }

  if (!data.data) return null;

  return (
    <div className="width-100 m-t-16 flex-center-center-column-nowrap">
      <div className="boldText6">{t('DELIVERY.DELIVERY_STATUS')}</div>
      <div className="margin-t-16 simpleBorder p-12 width-100 max-width-900">
        <div className="normalText5 m-b-6">
          <b>{t('DELIVERY.NEW_DELIVERY_MARK_PLACEHOLDER')}</b>: {data.data.invoiceMark}
        </div>
        <div className="normalText5">
          <b>{t('DELIVERY.DELIVERY_STATUS_CURRENT')}</b>: {t(`DELIVERY.STATUS.${data.data.status}`)}
        </div>
      </div>
      {data.data.lifecycleHistory && (
        <div className="margin-t-16 width-100 max-width-900">
          <DeliveryStatusSteps lifecycleHistory={data.data.lifecycleHistory} />
        </div>
      )}
      {/* Only populated for the issuer/recipient -- myDATA's document-retrieval methods don't
          extend to carriers the way GetDeliveryNoteStatus itself does, so this stays hidden
          (status/steps above still show) when the current user is neither. */}
      {data.extraData?.doc && (
        <div className="margin-t-16 width-100 max-width-900">
          <DeliveryStatusGsisDoc doc={data.extraData.doc} />
        </div>
      )}
    </div>
  );
};
